import { render, staticRenderFns } from "./ManagerCreateForm.vue?vue&type=template&id=6867779f&"
import script from "./ManagerCreateForm.vue?vue&type=script&lang=js&"
export * from "./ManagerCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports